import { render, staticRenderFns } from "./ReglasOperativasExport.vue?vue&type=template&id=200fdf3c"
import script from "./ReglasOperativasExport.vue?vue&type=script&lang=js"
export * from "./ReglasOperativasExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports